// Maps Base44 (+ legacy mock) order statuses to display + pill styling
export const STATUS_LABEL = {
  awaiting_inventory_check: "Awaiting Inventory",
  pending_payment: "Pending Payment",
  pending_payment_verification: "Verifying Payment",
  pending_bank_settlement: "Bank Settlement",
  processing: "Processing",
  picking: "Picking",
  building: "Building",
  packing: "Packing",
  ready_for_shipment: "Ready for Shipment",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
  order_error: "Order Error",
  // legacy
  pending: "Pending",
  in_production: "In Production",
  ready: "Ready",
};

export const STATUS_TONE = {
  awaiting_inventory_check: "bg-secondary text-muted-foreground border-border",
  pending_payment: "bg-[#E5A93D]/15 text-[#7c5a14] border-[#E5A93D]/40",
  pending_payment_verification: "bg-[#E5A93D]/15 text-[#7c5a14] border-[#E5A93D]/40",
  pending_bank_settlement: "bg-[#E5A93D]/15 text-[#7c5a14] border-[#E5A93D]/40",
  processing: "bg-primary/10 text-primary border-primary/30",
  picking: "bg-primary/10 text-primary border-primary/30",
  building: "bg-[#D66853]/15 text-[#a44231] border-[#D66853]/40",
  packing: "bg-[#D66853]/15 text-[#a44231] border-[#D66853]/40",
  ready_for_shipment: "bg-[#2C4C3B]/15 text-[#2C4C3B] border-[#2C4C3B]/40",
  shipped: "bg-[#2C4C3B]/15 text-[#2C4C3B] border-[#2C4C3B]/40",
  delivered: "bg-secondary text-muted-foreground border-border",
  cancelled: "bg-destructive/10 text-destructive border-destructive/30",
  order_error: "bg-destructive/10 text-destructive border-destructive/30",
  pending: "bg-[#E5A93D]/15 text-[#7c5a14] border-[#E5A93D]/40",
  in_production: "bg-primary/10 text-primary border-primary/30",
  ready: "bg-[#2C4C3B]/15 text-[#2C4C3B] border-[#2C4C3B]/40",
};

export const STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "awaiting_inventory_check", label: "Awaiting Inventory" },
  { value: "pending_payment", label: "Pending Payment" },
  { value: "processing", label: "Processing" },
  { value: "picking", label: "Picking" },
  { value: "building", label: "Building" },
  { value: "packing", label: "Packing" },
  { value: "ready_for_shipment", label: "Ready for Shipment" },
  { value: "shipped", label: "Shipped" },
  { value: "delivered", label: "Delivered" },
  { value: "cancelled", label: "Cancelled" },
];

export function StatusPill({ status, className = "" }) {
  const label = STATUS_LABEL[status] || (status || "—").toString().replace(/_/g, " ");
  const tone = STATUS_TONE[status] || "bg-secondary text-muted-foreground border-border";
  return (
    <span className={`pill ${tone} ${className}`}>
      {label}
    </span>
  );
}
